var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ratings"},_vm._l((_vm.ratings),function(rating){return _c('div',{key:rating.id,staticClass:"rating"},[_c('div',{staticClass:"stars"}),_c('blockquote',{staticClass:"text"},[_vm._v(" "+_vm._s(rating.text)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }